import { ChecksumAddress, makeAddressSync, ProtocolKey } from '@silo/types';
import { getConfigIsDeprecated } from '@silo/config';

type IsSiloDeprecated = { isDeprecated: false } | { isDeprecated: true; newSilo?: ChecksumAddress };

export const getIsSiloDeprecated = (
  protocolInstance: ProtocolKey,
  siloAddress: ChecksumAddress,
  markets?: {
    ids: ChecksumAddress[];
    getIsMarketArchived: (id: ChecksumAddress) => boolean;
  }
): IsSiloDeprecated => {
  if (!siloAddress) return { isDeprecated: false };

  const marketAddress = makeAddressSync(siloAddress);

  if (getConfigIsDeprecated({ protocolKey: protocolInstance, marketAddress })) {
    return { isDeprecated: true };
  }

  if (!markets) return { isDeprecated: false };

  const deprecatedSilo = markets.ids.find((market) => market === siloAddress && markets.getIsMarketArchived(market));

  if (!deprecatedSilo) return { isDeprecated: false };

  const newSilo = markets.ids.find((market) => market === deprecatedSilo && !markets.getIsMarketArchived(market));

  if (!newSilo) return { isDeprecated: false };

  return {
    isDeprecated: true,
    newSilo,
  };
};
